export default __webpack_public_path__ + "static/media/WordPressSolutions.59e03441.png";